import { render } from "./KindergardenForm.vue?vue&type=template&id=58211461&scoped=true"
import script from "./KindergardenForm.vue?vue&type=script&lang=js"
export * from "./KindergardenForm.vue?vue&type=script&lang=js"

import "./KindergardenForm.vue?vue&type=style&index=0&id=58211461&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58211461"]])

export default __exports__